module.exports = __webpack_public_path__ + "static/img/niurou.7854aa25.png";